// frontend/src/components/FallingHearts.tsx

import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const HEART_EMOJIS = ['💖','💕','💗','💓','💞','💝','❤️','🩷','💜',];

const FallingHearts: React.FC = () => {
  const hearts = useMemo(() => Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    duration: 6 + Math.random() * 8,
    delay: Math.random() * 6,
    size: ['text-lg','text-xl','text-2xl','text-3xl'][Math.floor(Math.random()*4)],
    emoji: HEART_EMOJIS[Math.floor(Math.random()*HEART_EMOJIS.length)],
    opacity: 0.3 + Math.random() * 0.5,
    drift: (Math.random() - 0.5) * 120
  })), []);
  // rest stay the same, only the hearts array is generated once on mount

  return (
    <div
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden"
      style={{ width: '100vw', height: '100vh' }}
    >

      {hearts.map((heart) => (
        <motion.div
          key={heart.id}

          className={`absolute ${heart.size}`}

          style={{
            left: heart.left,
            top: '-60px',
            opacity: heart.opacity
          }}

          animate={{
            y: ['0vh','110vh'],
            x: [0, heart.drift],
            rotate: [0,360],
            opacity: [heart.opacity, heart.opacity * 0.7, 0]
          }}

          transition={{
            duration: heart.duration,
            repeat: Infinity,
            delay: heart.delay,
            ease: "linear"
          }}
        >
          {heart.emoji}
        </motion.div>
      ))}

    </div>
  );
};

export default FallingHearts;